import StaticContent from './StaticContent';

export default StaticContent;
